import { Button, Container, Stack } from "@mui/material";

const G0201Rac = () => {

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg">
                <Stack spacing={2} >
                  <h1>残留農薬</h1>

                  <Button href="./G02012RacUpload"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    一括登録
                  </Button>

                  <Button href="./G02010RacQuarantineList"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    残留農薬検疫
                  </Button>

                  <Button href="./G02013RacPesticideProducts"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    農薬の製品名
                  </Button>

                  {/* <Button href="./G0202RacItemCommon"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    品目共通項目
                  </Button>

                  <Button href="./G0203RacCountry"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    各国資料
                  </Button>

                  <Button href="./G0204RacStdValue"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    基準値
                  </Button>
                  
                  <Button href="./G0205RacPesticide"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    農薬
                  </Button> */}

                  <Button href="./G0206RacProduct"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    品目
                  </Button>

                  <Button href="./G0207RacExport"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    輸出先
                  </Button>

                  <Button href="./G0208RacJa"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    和名頭文字
                  </Button>

                  <Button href="./G0209RacEn"
                    style={{
                      width: "200px"
                      , color: "white"
                      , textDecoration: "none"
                    }}>
                    英名頭文字
                  </Button>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G0201Rac;